<template>
  <aside
    v-if="tour"
    class="pti-card"
    role="region"
    aria-labelledby="page-tour-invite-title"
  >
    <div class="pti-inner">
      <h2 id="page-tour-invite-title" class="pti-title">{{ tour.invitationTitle }}</h2>
      <p class="pti-body">{{ tour.invitationBody }}</p>
      <div class="pti-actions">
        <button type="button" class="pti-btn pti-btn--primary" @click="onShow">
          Show me around
        </button>
        <button type="button" class="pti-btn pti-btn--ghost" @click="onDismiss">
          Not now
        </button>
      </div>
    </div>
  </aside>
</template>

<script>
import { computed } from 'vue';
import { useTutorialProgress } from '@/composables/useTutorialProgress';

export default {
  name: 'TutorialPageTourInvitation',
  setup() {
    const tutorial = useTutorialProgress();
    const tour = computed(() => tutorial.getPageTourInvitation());

    function onShow() {
      tutorial.acceptPageTourInvitation();
    }

    function onDismiss() {
      tutorial.dismissPageTourInvitation({ persist: true });
    }

    return { tour, onShow, onDismiss };
  },
};
</script>

<style scoped>
.pti-card {
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: calc(72px + env(safe-area-inset-bottom, 0px));
  z-index: 3050;
  display: flex;
  justify-content: center;
  pointer-events: none;
  text-align: left;
  font-family: 'Titillium Web', sans-serif;
}

.pti-inner {
  pointer-events: auto;
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  color: #0f172a;
  border-radius: 14px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.18);
  box-sizing: border-box;
}

.pti-title {
  margin: 0 0 8px;
  font-size: 1.05rem;
  font-weight: 900;
}

.pti-body {
  margin: 0 0 14px;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #475569;
}

.pti-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pti-btn {
  min-height: 44px;
  padding: 8px 14px;
  border-radius: 10px;
  font-family: inherit;
  font-size: 0.88rem;
  font-weight: 800;
  cursor: pointer;
}

.pti-btn--primary {
  background: #0b7ee3;
  color: #fff;
  border: none;
}

.pti-btn--ghost {
  background: #fff;
  color: #334155;
  border: 1px solid #e2e8f0;
}

.pti-btn:focus-visible {
  outline: 3px solid rgba(11, 126, 227, 0.35);
  outline-offset: 2px;
}

@media (min-width: 914px) {
  .pti-card {
    left: auto;
    right: 24px;
    bottom: 24px;
    justify-content: flex-end;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pti-card,
  .pti-inner {
    transition: none;
  }
}
</style>
